module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/information_icon.1bf37f0e.svg";